import reducer from "./reducers";
import sagas from "./sagas";
// 服务端渲染初始化数据
import model from "./models";
import newModel from "./routes/appdetail-v2/model"
import thunk from "./utils/thunk";

const Immutable = require('immutable');
const {createStore, applyMiddleware, compose} = require("redux");

// 服务端渲染数据
const initialState = {};

const createSagaMiddleware = require("redux-saga").default;

const sagaMiddleware = createSagaMiddleware();
export const asyncSaga = sagaMiddleware;

const middleware = applyMiddleware(sagaMiddleware, thunk);
// __REDUX_DEVTOOLS_EXTENSION__ 导致 replaceReducer 执行 dispatch
const enhancer = typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== "undefined" ? compose(
  middleware,
  window.__REDUX_DEVTOOLS_EXTENSION__()
) : middleware;

export default createStore(
  reducer,
  Immutable.fromJS({root: {...model,...newModel, ...initialState}}),
  enhancer
);

asyncSaga.run(sagas);
